import { render, staticRenderFns } from "./TarjetaEquipo.vue?vue&type=template&id=542846aa&"
import script from "./TarjetaEquipo.vue?vue&type=script&lang=js&"
export * from "./TarjetaEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports